import { CheckCircle2, Circle } from "lucide-react";
import {
  getPasswordRequirements,
  PASSWORD_REQUIREMENT_TEXT,
} from "@/lib/passwordPolicy";

export function PasswordRequirements({ password }: { password: string }) {
  const requirements = getPasswordRequirements(password);
  const isEntered = password.length > 0;

  return (
    <div
      id="password-requirements"
      className="rounded-lg border border-border bg-muted/35 px-3 py-2.5"
      aria-live="polite"
      data-testid="password-requirements"
    >
      <p className="mb-1.5 text-xs font-medium text-foreground">
        Create a strong password
      </p>
      <ul className="grid gap-1 text-xs sm:grid-cols-2">
        {requirements.map((requirement) => {
          const complete = isEntered && requirement.met;
          return (
            <li
              key={requirement.key}
              className={`flex items-center gap-1.5 ${
                complete ? "text-emerald-600 dark:text-emerald-400" : "text-muted-foreground"
              }`}
            >
              {complete ? (
                <CheckCircle2 className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
              ) : (
                <Circle className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
              )}
              {requirement.label}
            </li>
          );
        })}
      </ul>
      {!isEntered && (
        <p className="mt-1.5 text-xs text-muted-foreground">
          {PASSWORD_REQUIREMENT_TEXT}
        </p>
      )}
    </div>
  );
}